<form #form="ngForm" (ngSubmit)="save(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Employees -->
    <div class="p-field p-col-12 p-md-8">
      <span class="p-float-label">
        <p-dropdown [options]="employees" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    inputid="employee"
                    name="employees"
                    optionLabel="name"
                    optionValue="id"
                    dataKey="id"
                    required
                    [filter]="true"
                    #employee="ngModel"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="employeeTrainingRecord.employeeId"
                    [class.field-error]="form.submitted && employee.invalid">
            <ng-template let-employee pTemplate="item">
              <span >{{ getEmployeeName(employee) }}</span>
            </ng-template>                      
          </p-dropdown>
        <label for="employee" class="required-field">Employee</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && employee.invalid">Employee is required!</small>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <!--Courses -->
    <div class="p-field p-col-12 p-md-12">
      <span class="p-float-label">
        <p-dropdown [options]="courses" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputid="course"
                    name="course"
                    optionLabel="title"
                    optionValue="id"
                    dataKey="id"
                    required
                    #course="ngModel"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="employeeTrainingRecord.courseId"
                    [class.field-error]="form.submitted && course.invalid"></p-dropdown>
        <label for="course" class="required-field">Training Course</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && course.invalid">Training course is required!</small>
    </div>
  </div>


  <!-- Row 2 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Enrollment Date-->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="enrollmentDate"
                    name="enrollmentDate"
                    required
                    #enrollmentDate="ngModel"
                    [(ngModel)]="employeeTrainingRecord.enrollmentDate"
                    [class.field-error]="form.submitted && enrollmentDate.invalid"></p-calendar>
        <label for="enrollmentDate" class="required-field">Enrollment Date</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && enrollmentDate.invalid">Enrollment date is required</small>
    </div>

    <!--Completion Date-->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="completionDate"
                    name="completionDate"
                    #completionDate="ngModel"
                    [(ngModel)]="employeeTrainingRecord.completionDate"
                    [class.field-error]="form.submitted && completionDate.invalid"></p-calendar>
        <label for="completionDate" class="required-field">Completion Date</label>
      </span>
    </div>

    <!--Cost-->
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-inputNumber  name="cost"
                        id="cost" 
                        class="p-inputtext-sm"
                        mode="decimal" 
                        [minFractionDigits]="2"
                        #cost="ngModel"
                        [class.field-error]="form.submitted && cost.invalid"
                        [(ngModel)]="employeeTrainingRecord.cost"></p-inputNumber>
        <label for="cost" class="required-field">Cost</label>
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button p-button-raised" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel();"></button>
  </div>
</form>

